import {
	Activity as ActivityIcon,
	Bike,
	Dumbbell,
	Footprints,
	type LucideIcon,
	Mountain,
	StretchHorizontal,
	Waves,
} from "lucide-react";
import type { ActivityType } from "./types";

export const ACTIVITY_TYPE_LABELS: Record<ActivityType, string> = {
	run: "Run",
	ride: "Ride",
	swim: "Swim",
	strength: "Strength",
	mobility: "Mobility",
	hike: "Hike",
	other: "Other",
};

export const ACTIVITY_TYPE_ICONS: Record<ActivityType, LucideIcon> = {
	run: Footprints,
	ride: Bike,
	swim: Waves,
	strength: Dumbbell,
	mobility: StretchHorizontal,
	hike: Mountain,
	other: ActivityIcon,
};

/** Human duration from seconds, e.g. 3725 → "1h 2m". */
export function formatDuration(sec: number | null): string | null {
	if (sec == null) return null;
	const h = Math.floor(sec / 3600);
	const m = Math.round((sec % 3600) / 60);
	if (h > 0) return `${h}h ${m}m`;
	if (m > 0) return `${m}m`;
	return `${sec}s`;
}

/** Meters → "12.4 km" or "850 m". */
export function formatDistance(m: number | null): string | null {
	if (m == null) return null;
	if (m >= 1000) return `${(m / 1000).toFixed(m % 1000 === 0 ? 0 : 1)} km`;
	return `${m} m`;
}

/** A "YYYY-MM-DD" local date → "May 25" (no timezone shift: parsed as a plain date). */
export function formatLocalDate(localDate: string): string {
	const [y, m, d] = localDate.split("-").map(Number);
	return new Date(y ?? 1970, (m ?? 1) - 1, d ?? 1).toLocaleDateString(undefined, {
		month: "short",
		day: "numeric",
	});
}

/** Friendly relative label for a date string. */
export function formatRelativeDay(localDate: string, today: string): string {
	if (localDate === today) return "Today";
	const a = Date.parse(`${localDate}T00:00:00Z`);
	const b = Date.parse(`${today}T00:00:00Z`);
	const diff = Math.round((b - a) / 86_400_000);
	if (diff === 1) return "Yesterday";
	if (diff > 1 && diff < 7) return `${diff} days ago`;
	return formatLocalDate(localDate);
}
